import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider} from "react-redux";
import {store} from "./app/store";
import reportWebVitals from './reportWebVitals';
import {browserDeps, installStaleBuildGuard} from './app/staleBuild/staleBuild';

// stale-build-recovery T2: after a deploy an open tab asks for chunks the
// server no longer has; the guard reloads the page once instead of leaving a
// broken screen.
installStaleBuildGuard(browserDeps());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
